<template>
    <modal ref="verImagenUnica" titulo="" tamano="modal-lg">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-10">
                    <img :src="src" alt="" class="w-100">
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
export default {
    data(){
        return{
            inputComentario:'',
            src:'/img/pruebas/anuncio1.png'
        }
    },
    methods:{
        toggle(src){
          this.src = src
            this.$refs.verImagenUnica.toggle()
        },
        guardarValores(){
            this.$refs.verImagenUnica.toggle()
        }
    }
}
</script>
<style lang="scss" scoped>

</style>